import getImageFromEntry, { SQUARE } from './get-image-from-entry'
import { getOccurrences, isExpired } from './occurrences'
import { filterExpiredOccurrence } from './filter-expired-occurance'

const getWhatsHappeningItem = (item, centre) => {
  const image = getImageFromEntry(item, SQUARE)
  const category = item.__typename.toLowerCase()
  const occurrences = getOccurrences(true, item, centre.timeZone)
  const filteredOccurrences = filterExpiredOccurrence(occurrences)
  const expired = isExpired(item, centre.timeZone)

  return {
    sys: item.sys,
    __typename: item.__typename,
    slug: item.slug,
    link: `/${centre.slug}/${category}/${item.sys.id}/${item.slug}`,
    heading: item.title,
    expired,
    category,
    body: item.shortDescription,
    image,
    occurrences: filteredOccurrences,
    analyticsMetadata: item.analyticsMetadata,
  }
}

export default getWhatsHappeningItem
